import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

/**
 * Custom `text-*` sizes have to be declared here or tailwind-merge cannot tell
 * them from `text-*` colours: both match the same prefix, so it treats them as
 * one conflicting group and keeps only the last. A size and a colour on the same
 * element then silently loses the size — no error, no warning, the element just
 * renders at the inherited 16px.
 *
 * Every key added to `v2FontSize` or the apps' `theme.fontSize` belongs in this
 * list.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'headline',
            'kpi',
            'eyebrow',
            'caption',
            'micro',
            'v2-eyebrow',
            'v2-xs',
            'v2-sm',
            'v2-base',
            'v2-lg',
          ],
        },
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}